import React from "react";
import { MotifTooltip, MotifCheckbox } from "@ey-xd/motif-react";
import {PRODUCT_TOOLTIP_TEXT} from "./Constants";

interface CheckBoxToolTipProps {
    isDisabled: boolean;
    checked: boolean;
    onChange?: () => void;
    tooltipText?: string;
    checkboxClassName?: string;
}

const CheckBoxToolTip: React.FC<CheckBoxToolTipProps> = ({
    isDisabled,
    checked,
    onChange,
    tooltipText = PRODUCT_TOOLTIP_TEXT,
    checkboxClassName = "",
}) => {
    if (isDisabled) {
        return (
            <MotifTooltip
                contentClassName="tooltip-content"
                allowHover
                hideArrow={false}
                trigger={
                    <div className="disabled-checkbox-wrapper" 
                        onClick={(e) => e.preventDefault()}
                        onMouseDown={(e) => e.preventDefault()}
                        >
                        <MotifCheckbox
                            id="checkbox-example"
                            name="checkbox-example"
                            disabled={true}
                            checked={checked}
                            className={checkboxClassName}
                        >
                            {""}
                        </MotifCheckbox>
                    </div>
                }
            >
                {tooltipText}
            </MotifTooltip>
        );
    }

    return (
        <MotifCheckbox
            id="checkbox-example"
            name="checkbox-example"
            disabled={false}
            checked={checked}
            onChange={onChange}
            className={checkboxClassName}
        >
            {""}
        </MotifCheckbox>
    );
};

export default CheckBoxToolTip;
